import React from 'react';

import { RegionSwitcherSelector } from '@amzn/d16-g-adsp-region-switcher-ui';
import { useRegionSwitcherContext } from './RegionSwitcherProvider';
import { MarketplaceSwitcherProps } from 'src/features/header/components/MarketplaceSwitcher/MarketplaceSwitcher';
import { formatLocale } from 'src/providers/PantherLocalizationProvider/mbm';
import { useInternalChromeConfigContext } from 'src/providers/InternalChromeConfigContextProvider';
import useIsFeatureEnabled from 'src/commons/hooks/useIsFeatureEnabled';
import { WeblabedFeatures } from 'src/commons/constants';
import { appendLegacyMetricsParamIfEnabled } from 'src/commons/utils/urlRewriteRules';

const RegionSwitcher: React.VFC<MarketplaceSwitcherProps> = () => {
  const { accounts, currentAccount } = useRegionSwitcherContext();
  const isScopingNavEnabled = useIsFeatureEnabled(
    WeblabedFeatures.ADPT_SCOPING_NAV_DSP_OVERVIEW_ROLLOVER,
  );
  const isAndonCordEnabled = useIsFeatureEnabled(
    WeblabedFeatures.LEGACY_CONVERSION_METRICS_URL_REWRITE_ANDON_CORD,
  );

  const handleSelect = (selected) => {
    if (selected?.url) {
      const redirectUrl = new URL(`https://${selected.url}`);

      // Append legacy metrics param when switching regions so the state
      // carries across to the new domain.
      if (isScopingNavEnabled && !isAndonCordEnabled) {
        appendLegacyMetricsParamIfEnabled(redirectUrl);
      }

      window.location.assign(redirectUrl.toString());
    }
  };

  const { config: internalChromeConfig } = useInternalChromeConfigContext();

  if (
    !accounts ||
    !currentAccount ||
    (Array.isArray(accounts) && accounts.length == 0)
  ) {
    return null;
  }
  return (
    <RegionSwitcherSelector
      id="aac-chrome"
      currentAccount={currentAccount}
      accounts={accounts}
      language={formatLocale(internalChromeConfig.locale)}
      onSelect={handleSelect}
    />
  );
};

export default RegionSwitcher;
